export const RtxPreset = {
  'No RTX Preview': -1,
  Preview: 0,
  Low: 1,
  Medium: 2,
  High: 3,
  'Ultra High': 4,
  Epic: 5,
  Unlit: 6,
};

export const RtxPresetOptionNames = {
  [RtxPreset['No RTX Preview']]: 'Preview',
  [RtxPreset.Preview]: 'Preview RTX',
  [RtxPreset.Low]: 'Low',
  [RtxPreset.Medium]: 'Medium',
  [RtxPreset.High]: 'High',
  [RtxPreset['Ultra High']]: 'Ultra Hig',
  [RtxPreset.Epic]: 'Epic',
  [RtxPreset.Unlit]: 'Unlit',
};
